import { createSelector } from '@ngrx/store';
import { createFeatureSelector } from '@ngrx/store';
import { IActionsBtn } from './actions-selected-plan.reducer';

export const selectActionsBtnState = createFeatureSelector<IActionsBtn>('tickets');
export const selectActionsBtn = createSelector(selectActionsBtnState, (state) => {
  return state;
});
export const currentStepSelector = createSelector(
  selectActionsBtn,
  (state) => state.current_step,
);
export const allowEmptyTicketSelector = createSelector(
  selectActionsBtn,
  (state) => state.allow_empty_ticket,
);
export const selectedRateSelector = createSelector(
  selectActionsBtn,
  (state) => state.selected_rate,
);
export const mealPlanByTicketSelector = createSelector(
  selectActionsBtn,
  (state) => state.meal_play_by_selected_ticket,
);
export const ticketSelectedSelector = createSelector(
  selectActionsBtn,
  (state) => state.ticket_selected,
);

export const bookRate = createSelector(selectActionsBtn, (state) => {
  return {
    rate: state.selected_rate,
    start_ticket: state.start_ticket,
  };
});

export const loadingSelector = createSelector(selectActionsBtn, (state) => {
  return state.loading;
});
